export const chipStyles = {
  height: 'fit-content',
  flexShrink: 0,
  // Never wider than whatever holds it, a chip that outgrows its container
  // ends with an ellipsis inside its own background instead of being sliced
  // off by the container's edge.
  maxWidth: '100%',
  whiteSpace: 'nowrap',
  '.MuiChip-label': {
    fontFamily: 'helvetica-neue-lt-pro-cond, sans-serif',
    fontWeight: 900,
    fontSize: '14px',
    lineHeight: '20px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  '.MuiChip-icon': {
    color: 'inherit'
  }
}

export const chipImageStyles = {
  height: '1rem',
  filter: 'invert(100%)'
}
